export const CAMPO_OBRIGATORIO = "O preenchimento deste campo é obrigatorio";
